import styled from 'styled-components'
import device from '../../utilities/device'

const SidePageTextBox = styled.div`
  max-width: 800px;
  width: 100%;
  > h1 {
    font-family: 'Open Sans', Arial, Helvetica, sans-serif;
    font-size: 40px;
    @media ${device.laptop} {
      font-size: 32px;
    }
  }
  > h2 {
    font-size: 30px;
    color: ${({ theme }) => theme.colorLightBlue};
    line-height: 1.2em;
    margin: 10px 0px;
    @media ${device.laptop} {
      margin-top: 20px;
    }
  }
  > p {
    @media ${device.laptop} {
      font-size: 18px;
      line-height: 1.4em;
    }
  }
  @media ${device.laptop} {
    max-width: 80%;
  }
  @media ${device.mobileL} {
    max-width: 90%;
  }
`
export default SidePageTextBox
